import { NotificationBanner } from '@models/notification-banner';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.scss']
})
export class BannerNotificationComponent implements OnInit {
  @Input() banner: NotificationBanner = null;
  public showBannerNotification = true;

  constructor() {}

  ngOnInit() {}

  // ! Used in this way to achieve a progressive dissappearing animation by css
  public dismissBannerNotification(callbackFn = null) {
    this.showBannerNotification = false;
    if (callbackFn) callbackFn();
  }

  public async asyncDismissBannerNotification() {
    this.showBannerNotification = false;
    return !this.showBannerNotification;
  }
}
